import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
interface AgentResponse {
  id: string;
  name: string;
  avatar: string;
  intro: string;
  creator_id: string;
  workflow: string;
  workflow_address: string;
  created_at: string;
  updated_at: string;
}

export class AgentDetailData {
  @Required("ID cannot be empty")
  @IsString("ID must be a string")
  id: string;

  @IsString("Workflow must be a string")
  workflow: string | null;

  @IsString("Workflow Address must be a string")
  workflowAddress: string | null;

  @IsNumber("Subscription Time must be a number")
  subscriptionTime: number | null;

  @IsNumber("Subscription Frequency must be a number")
  subscriptionFrequency: number | null;
}

const transformAndValidateAgent = (
  response: AgentResponse
): AgentDetailData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AgentDetailData);
  } catch (error) {
    console.error("Agent detail validation failed:", error.message);
    throw error;
  }
};

/** 获取 Agent 详情 */
export const agentDetail = async (id: string): Promise<AgentDetailData> => {
  const response = await api.get<AgentResponse>(`/agent/detail/${id}`);
  const data = transformAndValidateAgent(response.data);
  return data;
};
